import { css } from '@emotion/react'
import { ReactNode } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'

type Props = {
  children: ReactNode
  withPadding?: boolean
}

/**
 * データの取得状態に関わらず必ず表示する部分を抜き出したコンポーネント
 */
export const AnalyticsWrapper = (props: Props) => {
  const { children, withPadding } = props

  return (
    <div>
      <Header>
        <HeaderTitle isBeta title="分析" />
      </Header>
      <div css={css({ padding: withPadding ? '24px' : 0 })}>{children}</div>
    </div>
  )
}
